import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import Log from 'forms-utils-lib/logger/Logger';
import { useFormAIWizard } from 'forms-ai-lib/hooks/useFormAIWizard';
// @ts-expect-error untyped dependency
import withPermissionsTooltip from 'FormsCommonComponents/withPermissionsTooltip';
import redirectToNewEditor from 'FormsUI/actions/formCreation/newEditor/redirectToNewEditor';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionedButton = withPermissionsTooltip(Button);
const StartWithAIButton = ({
  isRequestStatePending = false,
  formsWriteAccess = false
}) => {
  const {
    closeFormAIWizard,
    openFormAIWizard
  } = useFormAIWizard();
  const onClick = useCallback(() => {
    trackDashboardInteraction('start-with-ai-button-clicked');
    openFormAIWizard().then(result => {
      if (!result.cancelled) {
        redirectToNewEditor(result.formId, 'normal');
        closeFormAIWizard();
      }
    }).catch(error => {
      Log.error(`Unable to generate form`, error);
    });
  }, [closeFormAIWizard, openFormAIWizard]);
  return /*#__PURE__*/_jsx(PermissionedButton, {
    "data-test-id": "start-with-ai-button",
    hasPermission: formsWriteAccess,
    disabled: isRequestStatePending,
    onClick: onClick,
    size: "small",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCreateForm.buttons.startWithAIButton"
    })
  });
};
export default StartWithAIButton;